<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="车位审核名称">
          <el-input placeholder="请输入车位审核名称" v-model="formInline.search">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加车位审核</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user_id" label="用户id"></el-table-column>
            <el-table-column prop="parking_space_name" label="车位"></el-table-column>
            <el-table-column prop="contact" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系时间"></el-table-column>
            <el-table-column prop="number" label="车辆号码"></el-table-column>
            <el-table-column prop="create_time" label="申请时间"></el-table-column>
              <el-table-column prop="status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : 'warning'">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 审核按钮（仅未审核状态显示） -->
                <el-button 
                  v-if="scope.row.status === 0" 
                  @click="showApproveDialog(scope.row)" 
                  type="text" 
                  size="small"
                 >
                  审核
                </el-button>
                
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :user_parks_id="user_parks_id" v-if="open_edit" @close="closeEdit"></Edit>

     <el-dialog
      title="审核车位申请"
      :visible.sync="approveDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      
      <el-form :model="approveForm" label-width="80px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="approveForm.status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <!-- <el-form-item label="审核备注" v-if="approveForm.status === 2">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入审核不通过的原因"
            v-model="approveForm.remark">
          </el-input>
        </el-form-item> -->
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleApproveSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
import User_parksApi from '@/api/user_parks.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      user_parks_id: "",
      dialogVisible: false,
      
      /* 审核相关数据 */
      approveDialogVisible: false,
      approveForm: {
        user_parks_id: null,
        status: 1, // 1:通过, 2:不通过
        remark: ""
      },
      currentApproveRow: null
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /* 获取状态文本 */
    getStatusText(status) {
      const statusMap = {
        0: '未审核',
        1: '已通过',
        2: '未通过'
      };
      return statusMap[status] || '未知状态';
    },
    
    /* 显示审核弹窗 */
    showApproveDialog(row) {
      this.currentApproveRow = row;
      this.approveForm = {
        user_parks_id: row.user_parks_id,
        status: 1,
        remark: ""
      };
      this.approveDialogVisible = true;
    },
    
    /* 处理审核提交 */
    handleApproveSubmit() {
      let self = this;
      
      User_parksApi.approve(this.approveForm, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              message: '审核操作成功',
              type: 'success'
            });
            this.approveDialogVisible = false;
            this.getTableList();
          } else {
            self.$message.error(data.msg || '审核操作失败');
          }
        })
        .catch(error => {
          self.$message.error('审核操作失败');
        });
    },
    
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) { //车位审核标题设置
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      User_parksApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    /*添加任务*/
    addClick() {
      this.open_add = true;
    },
    /*编辑活动*/
    editClick(row) {
      this.user_parks_id = row.user_parks_id;
      this.open_edit = true;
    },
    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        User_parksApi.del({
          user_parks_id: row.user_parks_id
        }, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getTableList();
          } else {
            self.$message.error('错了哦，这是一条错误消息');
          }
        })
        .catch(error => {
        });
      })
      .catch(() => {
      });
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/plus/user_parks/index/index.vue